/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShopOrderRequestUpdate {
  shippingCompanyName?: string;
  status?: ShopOrderRequestUpdate.StatusEnum;
}
export namespace ShopOrderRequestUpdate {
  export type StatusEnum =
    | 'PENDENTE'
    | 'CRIADO'
    | 'ERRO'
    | 'CANCELADO'
    | 'PERSISTIDO';
  export const StatusEnum = {
    PENDENTE: 'PENDENTE' as StatusEnum,
    CRIADO: 'CRIADO' as StatusEnum,
    ERRO: 'ERRO' as StatusEnum,
    CANCELADO: 'CANCELADO' as StatusEnum,
    PERSISTIDO: 'PERSISTIDO' as StatusEnum
  };
}
